import { ChangeDetectorRef, Component, effect, inject, OnDestroy, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DataBindingDirective, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_ICON } from '@progress/kendo-angular-icons';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { process, SortDescriptor } from '@progress/kendo-data-query';
import { SubSink } from 'subsink';
import { ProfileApiService } from '../apiCalls/profile-api.service';
import { RoutesConst } from '../shared/route-const';
import { DeleteUserComponent } from './delete-user/delete-user.component';

export interface UserListData {
  Id: number;
  Email: string;
  FirstName: string;
  LastName: string;
}

@Component({
  selector: 'app-user-management',
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule, RouterLink, KENDO_GRID, KENDO_ICON, KENDO_INPUTS, MatTooltipModule],
  templateUrl: './user-management.component.html',
  styleUrl: './user-management.component.scss',
})
export class UserManagementComponent implements OnDestroy {
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;

  private subs = new SubSink();

  routesConst = RoutesConst;

  private readonly profileApiSvc = inject(ProfileApiService);
  private readonly userData = this.profileApiSvc.getUsers();
  private readonly dialog = inject(MatDialog);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly router = inject(Router);
  private route = inject(ActivatedRoute);

  sort: SortDescriptor[] = [{ field: 'FirstName', dir: 'asc' }];
  loading = false;
  gridView: UserListData[] = [];

  showMainRoute = signal(true);

  constructor() {
    console.log('UserManagementComponent constructor');
    this.loading = true;

    // Load userData as httpResource and set gridView, data change, update gridView
    effect(() => {
      const data = this.userData() as UserListData[];
      if (data) {
        this.loading = false;
        this.gridView = data as UserListData[];
      }
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // Handle search input
  onFilter(value: string): void {
    const filterValue = value?.toLowerCase() ?? '';
    this.gridView = process(this.userData() ?? [], {
      filter: {
        logic: 'or',
        filters: [
          { field: 'FirstName', operator: 'contains', value: filterValue },
          { field: 'LastName', operator: 'contains', value: filterValue },
          { field: 'Email', operator: 'contains', value: filterValue },
        ],
      },
    }).data;

    this.dataBinding.skip = 0;
    this.cdRef.detectChanges();
  }

  deleteUser(user: UserListData): void {
    this.subs.sink = this.dialog
      .open(DeleteUserComponent, {
        data: user as UserListData,
        width: '25vw',
        minWidth: '400px',
        autoFocus: false,
      })
      .afterClosed()
      .subscribe((deleteConfirmed?: boolean) => {
        if (deleteConfirmed) {
          //
        }
      });
  }
}
